<template>
    <div>
        <v-tabs
            v-model="tab"
            align-tabs="center"
            bg-color="surface-variant"
            slider-color="secondary"
            show-arrows
        >
            <v-tab
                v-for="group in modelValue"
                :key="`comp-group-tab-${group.uid}`"
                :value="group.uid"
             >
                {{ group.name }}
            </v-tab>
        </v-tabs>
        <v-tabs-window
            v-model="tab"
        >
            <v-tabs-window-item
                v-for="group in modelValue"
                :key="`comp-group-tab-window-${group.uid}`"
                :value="group.uid"
            >
                <ComparisonGroupsTable
                    :model-value="group"
                    :product-uid="productUid"
                ></ComparisonGroupsTable>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductComparisonGroup
    } from '~/types';
    import ComparisonGroupsTable from '~/components/products/product/comparison-groups/ComparisonGroupsTable/ComparisonGroupsTable.vue';

    defineProps<{
        modelValue: ProductComparisonGroup[];
        productUid: string;
    }>();

    const tab = ref<number>();
</script>

<style lang="scss"></style>
